import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "column message" }
const _hoisted_3 = { class: "column controls" }

import { computed, reactive, ref } from 'vue'
import { ElUpload, FormInstance, InputInstance, FormRules, UploadUserFile } from 'element-plus'
import { Paperclip } from '@element-plus/icons-vue'
import { iChatMessageModel } from '@/types/common/models'
import useFormRequest from '@/composables/useFormRequest'

type iChatForm = {
  message: string
  files: UploadUserFile[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatForm',
  props: {
    submit: { type: Function }
  },
  emits: ['send'],
  setup(__props: any, { emit: __emit }) {

const uploadRef = ref<InstanceType<typeof ElUpload>>()
const formRequest = useFormRequest()
const formRef = ref<FormInstance>()
const inputRef = ref<InputInstance>()

const props = __props
const emit = __emit

const form = reactive<iChatForm>({
  message: '',
  files: []
})

const rules = computed<FormRules<iChatForm>>(() => {
  return form.files.length === 0
    ? {
        message: [
          { type: 'string', message: 'Напишите сообщение', trigger: 'change', required: true }
        ]
      }
    : {}
})

const addAttachment = () => {
  // @todo Избавиться от этого костыля
  (document.querySelector('.chat-form input[type=file]') as HTMLInputElement).click()
}

const handleSubmit = async () => {
  formRef.value?.validate(valid => {
    if (valid) {
      formRequest.tryRequest(async () => {
        const formData = new FormData()
        formData.append('message', form.message.trim())

        form.files.forEach(file => {
          if (file.raw instanceof Blob) {
            formData.append('files', file.raw)
          }
        })

        const response = await props.submit(formData)

        formRef.value?.resetFields()
        emit('send', response)
      })
    }
  })
}

const handleInputEnter = (e: KeyboardEvent) => {
  if (e.shiftKey) {
    return
  }

  handleSubmit()
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    class: "chat-form",
    model: form,
    rules: rules.value,
    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
    disabled: _unref(formRequest).state.pending
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        prop: "files",
        style: {"margin-bottom":"0"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElUpload), {
            ref_key: "uploadRef",
            ref: uploadRef,
            "file-list": form.files,
            "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((form.files) = $event)),
            style: {"width":"100%"},
            multiple: "",
            "auto-upload": false
          }, null, 8, ["file-list"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, { prop: "message" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                ref_key: "inputRef",
                ref: inputRef,
                modelValue: form.message,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.message) = $event)),
                autosize: { maxRows: 5 },
                type: "textarea",
                placeholder: "Текст сообщения",
                onKeyup: _withKeys(_withModifiers(handleInputEnter, ["prevent"]), ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_tooltip, { content: "Добавить вложение" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                onClick: addAttachment
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Paperclip))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("Отправить")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules", "disabled"]))
}
}

})